import i18next from 'i18next';
import { enTranslations } from '../i18n/en';
import { plTranslations } from '../i18n/pl';

// Get saved language preference or detect from browser
const savedLang = localStorage.getItem('lang');
const browserLang = navigator.language || navigator.userLanguage;
const defaultLang = savedLang || (browserLang.startsWith('en') ? 'en' : 'pl');

// Initialize i18next with translations
i18next
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      pl: {
        translation: plTranslations
      }
    },
    fallbackLng: 'pl',
    lng: defaultLang, // Set default language based on browser
    debug: false
  });

/**
 * Update all DOM elements that have data-i18n attribute
 */
function updateContent() {
  document.querySelectorAll('[data-i18n]').forEach(element => {
    const key = element.getAttribute('data-i18n');
    element.textContent = i18next.t(key);
  });
  document.querySelectorAll('[data-i18n-html]').forEach(element => {
    const key = element.getAttribute('data-i18n-html');
    element.innerHTML = i18next.t(key);
  });
  const page = document.documentElement.dataset.page;
  const titleKey = page === 'experience' ? 'pageTitleExperience'
                 : page === 'publications' ? 'pageTitlePublications'
                 : 'pageTitle';
  document.title = i18next.t(titleKey);
}

/**
 * Sets up the language switcher
 */
export function setupLanguageSwitcher() {
  // Make sure the HTML lang attribute is set immediately
  document.documentElement.setAttribute('lang', i18next.language);
  
  // Initial translation
  updateContent();
  document.documentElement.style.visibility = '';
  
  // Set active language button
  setActiveLanguageButton(i18next.language);
  
  // Add event listeners to language buttons
  const langButtons = document.querySelectorAll('.lang-btn');
  langButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const lang = btn.getAttribute('data-lang');
      localStorage.setItem('lang', lang);
      i18next.changeLanguage(lang, () => {
        setActiveLanguageButton(lang);
      });
    });
  });
  
  // Language change event
  i18next.on('languageChanged', () => {
    updateContent();
    document.documentElement.setAttribute('lang', i18next.language);
  });
}

/**
 * Set the active language button
 * @param {string} lang - Language code (en/pl)
 */
function setActiveLanguageButton(lang) {
  const langButtons = document.querySelectorAll('.lang-btn');
  langButtons.forEach(btn => {
    if (btn.getAttribute('data-lang') === lang) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });
  
  // Set the HTML lang attribute
  document.documentElement.setAttribute('lang', lang);
} 